// [MCV-1332] Single source of truth for the contact tables' column widths.
// Each table uses `table-fixed` + one of these <colgroup>s (defined once here).
//
// Design:
//  - The lead "Type" column, the trailing narrow column, and the actions column
//    share widths across the tables, so the left edge, that narrow column, and
//    the Edit/Delete controls line up down the stacked view.
//  - Middle columns hold different data per table, so each table sizes them for
//    its own content: Address lets its two text columns flex; Phone pins the
//    short Country Code to a narrow width and lets Phone Number absorb the slack
//    (otherwise Country Code shares the flex space and opens a big gap before the
//    number).
//  - Email's lead column holds full email addresses, so it stays flexible; only
//    the actions column is forced to match the others.

// Trailing Edit/Delete column — identical across all three tables.
const ACTIONS_COL = 'w-28';
// Narrow fixed column (Postal Code / Primary check / Country Code).
const NARROW_COL = 'w-32';
// Lead "Type" column.
const TYPE_COL = 'w-40';

// Address: Type | Address (flex) | Address Line 2 (flex) | Postal Code | actions
export const AddressColgroup = () => (
  <colgroup>
    <col className={TYPE_COL} />
    <col />
    <col />
    <col className={NARROW_COL} />
    <col className={ACTIONS_COL} />
  </colgroup>
);

// Phone: Type | Country Code (narrow) | Phone Number (flex) | Primary | actions
export const PhoneColgroup = () => (
  <colgroup>
    <col className={TYPE_COL} />
    <col className={NARROW_COL} />
    <col />
    <col className={NARROW_COL} />
    <col className={ACTIONS_COL} />
  </colgroup>
);

// Email: Email Address (flex) | Primary | actions
export const EmailColgroup = () => (
  <colgroup>
    <col />
    <col className={NARROW_COL} />
    <col className={ACTIONS_COL} />
  </colgroup>
);
